// The "last option" in any color row: a colorful circle that opens the browser's full color
// picker (so the palette swatches aren't the only choices). Shared by the floating toolbar and
// the dock inspector. stopPropagation so opening it doesn't deselect the layer.

import type { CSSProperties } from 'react'

const RAINBOW: CSSProperties = {
  background:
    'conic-gradient(from 0deg, #ff0040, #ffd000, #37ff00, #00e5ff, #2b00ff, #ff00d4, #ff0040)',
}

/** input[type=color] needs a 6-digit hex; fall back to black for named/rgb values. */
function toHex(value: string): string {
  return /^#([0-9a-f]{6})$/i.test(value) ? value : '#000000'
}

export function ColorPickerSwatch({
  value,
  onPick,
  size = 20,
}: {
  value: string
  onPick: (color: string) => void
  size?: number
}) {
  return (
    <label
      title="Custom color"
      onPointerDown={e => e.stopPropagation()}
      className="relative inline-flex flex-shrink-0 cursor-pointer items-center justify-center rounded-full border border-black/10"
      style={{ width: size, height: size, ...RAINBOW }}
    >
      <input
        type="color"
        value={toHex(value)}
        onChange={e => onPick(e.target.value)}
        className="absolute inset-0 h-full w-full cursor-pointer opacity-0"
        aria-label="Pick a custom color"
      />
    </label>
  )
}
